import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-6"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_4 = { class: "flex-grow flex flex-col justify-center" }
const _hoisted_5 = { class: "flex flex-wrap items-center gap-x-4 gap-y-2" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "font-extrabold text-gray-900 text-lg" }
const _hoisted_8 = {
  key: 0,
  class: "text-[10px] text-indigo-600 font-bold mt-0.5"
}
const _hoisted_9 = { class: "flex items-center gap-1.5 text-gray-500 text-sm font-semibold" }
const _hoisted_10 = { class: "flex flex-col sm:flex-row sm:items-center gap-x-6 gap-y-2 mt-3 text-xs text-gray-500 border-t border-gray-50/50 pt-2.5" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "font-bold text-gray-700 text-sm" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-wrap items-center gap-2 flex-1 text-xs md:text-sm"
}
const _hoisted_14 = { class: "font-bold text-gray-800 line-clamp-1 max-w-[280px]" }
const _hoisted_15 = { class: "font-bold text-gray-800 line-clamp-1 max-w-[280px]" }
const _hoisted_16 = {
  key: 1,
  class: "ml-2 px-2 py-0.5 rounded bg-gray-100 text-gray-600 font-bold text-[10px] uppercase"
}
const _hoisted_17 = {
  key: 0,
  class: "flex flex-wrap items-center gap-2 flex-shrink-0 border-t md:border-t-0 pt-3 md:pt-0 border-gray-50"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "text-center py-16 bg-gray-50/50 rounded-2xl border border-dashed border-gray-200 p-8"
}
const _hoisted_23 = { class: "flex flex-col gap-4 bg-gray-50/50 p-4 rounded-2xl mb-4 border border-gray-100/85 shadow-sm" }
const _hoisted_24 = { class: "flex flex-col sm:flex-row gap-3 w-full justify-between items-center" }
const _hoisted_25 = { class: "flex gap-2 justify-end w-full sm:w-auto" }
const _hoisted_26 = { class: "flex flex-wrap gap-3 items-center w-full" }
const _hoisted_27 = { class: "relative flex-grow sm:flex-grow-0" }
const _hoisted_28 = { class: "relative w-full sm:w-48" }
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 0,
  class: "flex items-center gap-2 w-full sm:w-auto"
}
const _hoisted_31 = { class: "relative w-full sm:w-44" }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 1,
  class: "relative w-full sm:w-48"
}
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 2,
  class: "relative w-full sm:w-44"
}
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "font-bold text-gray-900 text-sm" }
const _hoisted_38 = {
  key: 0,
  class: "text-[10px] text-indigo-600 font-bold mt-0.5"
}
const _hoisted_39 = { class: "text-xs text-gray-500 font-medium mt-1" }
const _hoisted_40 = { class: "flex flex-col gap-1 text-xs text-gray-700" }
const _hoisted_41 = { class: "flex items-center gap-1.5" }
const _hoisted_42 = { class: "font-semibold text-gray-600" }
const _hoisted_43 = { class: "flex items-center gap-1.5" }
const _hoisted_44 = { class: "font-medium text-gray-600" }
const _hoisted_45 = { class: "flex items-center gap-1.5" }
const _hoisted_46 = { class: "font-semibold text-theme-active" }
const _hoisted_47 = {
  key: 0,
  class: "flex items-center gap-1.5 mt-1"
}
const _hoisted_48 = { class: "px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 font-extrabold text-[10px] uppercase border border-emerald-200" }
const _hoisted_49 = { class: "flex flex-col gap-0.5 mt-1 border-t border-gray-100 pt-1.5" }
const _hoisted_50 = { class: "flex items-start gap-1" }
const _hoisted_51 = ["title"]
const _hoisted_52 = {
  key: 0,
  class: "flex items-start gap-1"
}
const _hoisted_53 = ["title"]
const _hoisted_54 = {
  key: 1,
  class: "flex items-center gap-1"
}
const _hoisted_55 = { class: "px-2 py-0.5 rounded bg-gray-100 text-gray-600 font-bold text-[9px] uppercase" }
const _hoisted_56 = { class: "flex flex-col gap-1.5 justify-center" }
const _hoisted_57 = { class: "font-bold text-gray-900 text-sm" }
const _hoisted_58 = { class: "flex flex-col items-center gap-1" }
const _hoisted_59 = {
  key: 0,
  class: "text-[9px] text-gray-500 font-medium mt-0.5"
}
const _hoisted_60 = {
  key: 0,
  class: "flex flex-wrap items-center gap-1.5"
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  key: 1,
  class: "fixed top-[-9999px] left-[-9999px]",
  style: {"pointer-events":"none","width":"800px"}
}
const _hoisted_66 = {
  key: 2,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
}
const _hoisted_67 = { class: "bg-white rounded-2xl max-w-2xl w-full p-6 shadow-2xl flex flex-col max-h-[90vh] overflow-hidden" }
const _hoisted_68 = { class: "flex justify-between items-center pb-4 border-b" }
const _hoisted_69 = { class: "text-lg font-bold text-gray-900" }
const _hoisted_70 = {
  key: 0,
  class: "flex-grow overflow-y-auto py-4 space-y-4"
}
const _hoisted_71 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "relative" }
const _hoisted_74 = { class: "relative flex items-center" }
const _hoisted_75 = {
  key: 0,
  class: "absolute right-2.5"
}
const _hoisted_76 = {
  key: 0,
  class: "z-50 !mt-1 max-h-[200px] overflow-y-auto absolute top-full left-0 w-full shadow-lg bg-white border border-gray-200 rounded-lg"
}
const _hoisted_77 = ["onClick"]
const _hoisted_78 = {
  key: 0,
  class: "relative"
}
const _hoisted_79 = { class: "relative flex items-center" }
const _hoisted_80 = {
  key: 0,
  class: "absolute right-2.5"
}
const _hoisted_81 = {
  key: 0,
  class: "z-50 !mt-1 max-h-[200px] overflow-y-auto absolute top-full left-0 w-full shadow-lg bg-white border border-gray-200 rounded-lg"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 1,
  class: "flex-grow overflow-y-auto py-4 space-y-4"
}
const _hoisted_84 = { class: "text-sm font-semibold text-gray-600" }
const _hoisted_85 = { class: "font-bold text-gray-900" }
const _hoisted_86 = { class: "border rounded-xl divide-y bg-gray-50 overflow-hidden" }
const _hoisted_87 = { class: "font-bold text-gray-700" }
const _hoisted_88 = { class: "text-red-500 line-through truncate" }
const _hoisted_89 = { class: "text-green-600 font-semibold truncate" }
const _hoisted_90 = { class: "pt-4 border-t flex justify-end gap-2" }
const _hoisted_91 = {
  key: 3,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
}
const _hoisted_92 = { class: "bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl space-y-4" }
const _hoisted_93 = { class: "flex justify-between items-center pb-2 border-b" }
const _hoisted_94 = { class: "space-y-3" }
const _hoisted_95 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_96 = { class: "font-bold text-gray-950" }
const _hoisted_97 = {
  key: 0,
  class: "text-red-500 text-xs font-semibold mt-1"
}
const _hoisted_98 = { class: "pt-2 border-t flex justify-end gap-2" }
const _hoisted_99 = {
  key: 4,
  class: "text-center font-bold h-[50px] mt-12 w-full text-gray-400"
}

import { ref, onMounted, computed, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import Agent from '@/composables/admin/agent'
import Corporate from '@/composables/admin/corporate'
import axios from 'axios'
import { handleApiError, isLoggedIn, isAdminLoggedIn, saveBookingNumber, isMakePaymentVisible, formattedDateTime, logout, getBackendBaseUrl, getUserToken, sortPlacePredictions } from '@/utils/common'
import Location from '@/composables/Location'
import SlideOver from '@/widgets/SlideOver.vue'
import BookingDetails from '@/components/admin/BookingDetails.vue'
import Invoice from '@/components/booking/Invoice.vue'
import Voucher from '@/components/booking/Voucher.vue'
import Notification from '@/widgets/Notification.vue'
import { NotificationType } from '@/types/index'
// @ts-ignore
import html2pdf from 'html2pdf.js'
import { STATUSES } from '@/utils/constants'
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import { saveUserSearch } from '@/services/search-service'
import CarService from '@/services/car-service'
import Admin from '@/composables/admin'
import router from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingsTable',
  props: ['subUserId'],
  setup(__props) {

const { saveSelectedCar } = CarService()
const route = useRoute()
const bookings = ref<any>(null)
const selectedDateScope = ref<string>('this_month')
const startDate = ref<string>('')
const endDate = ref<string>('')
const scopes = ref([
   { id: 'all_time', name: 'Lifetime' },
   { id: 'today', name: 'Today' },
   { id: 'this_week', name: 'This Week' },
   { id: 'this_month', name: 'This Month' },
   { id: 'last_month', name: 'Last Month' },
   { id: 'this_year', name: 'This Year' },
   { id: 'last_year', name: 'Last Year' },
   { id: 'custom', name: 'Custom Date Range' }
])

const filteredBookings = computed(() => {
   if (!bookings.value) return []
   const scope = selectedDateScope.value
   if (scope === 'all_time') return bookings.value

   const now = new Date()
   let start: Date | null = null
   let end: Date | null = null

   if (scope === 'today') {
      start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
      end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
   } else if (scope === 'this_week') {
      const currentDay = now.getDay()
      const distance = now.getDate() - currentDay + (currentDay === 0 ? -6 : 1) // Start of week (Monday)
      start = new Date(now.setDate(distance))
      start.setHours(0,0,0,0)
      
      const lastday = new Date(start)
      lastday.setDate(start.getDate() + 6)
      end = new Date(lastday)
      end.setHours(23,59,59,999)
   } else if (scope === 'this_month') {
      start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0)
      end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59)
   } else if (scope === 'last_month') {
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0)
      end = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59)
   } else if (scope === 'this_year') {
      start = new Date(now.getFullYear(), 0, 1, 0, 0, 0)
      end = new Date(now.getFullYear(), 11, 31, 23, 59, 59)
   } else if (scope === 'last_year') {
      start = new Date(now.getFullYear() - 1, 0, 1, 0, 0, 0)
      end = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59)
   } else if (scope === 'custom') {
      if (startDate.value && endDate.value) {
         start = new Date(startDate.value)
         start.setHours(0,0,0,0)
         end = new Date(endDate.value)
         end.setHours(23,59,59,999)
      } else {
         return bookings.value
      }
   }

   if (!start || !end) return bookings.value

   const startTs = start.getTime() / 1000
   const endTs = end.getTime() / 1000

   return bookings.value.filter((b: any) => {
      if (!b.createdAt) return false
      return b.createdAt >= startTs && b.createdAt <= endTs
   })
})

const { allAgentBookings, subAgentBookings, subAgents } = Agent()
const { allCorporateBookings } = Corporate()
const { allBookings } = Admin()
const isLoading = ref<boolean>(true)
const openDialog = ref<boolean>(false)
const selectedBooking = ref<any>(null)
const props = __props 
let authAdminUser = ref<any>(null)

const { searchLocation } = Location()
const pickupAddresses = ref<any[]>([])
const dropoffAddresses = ref<any[]>([])
const isPickupLoading = ref(false)
const isDropoffLoading = ref(false)
const isPickupDropOpen = ref(false)
const isDropoffDropOpen = ref(false)
let pickupTimeout: ReturnType<typeof setTimeout> | null = null
let dropoffTimeout: ReturnType<typeof setTimeout> | null = null

const handlePickupSearch = () => {
   const val = editForm.value.pickup_location.trim()
   if (val.length > 2) {
      if (pickupTimeout) clearTimeout(pickupTimeout)
      pickupTimeout = setTimeout(async () => {
         isPickupLoading.value = true
         const response = await searchLocation(val)
         isPickupLoading.value = false
         if (response.status === 200) {
            const predictions = sortPlacePredictions(response.data.data)
            pickupAddresses.value = predictions.map((item: any) => ({
               name: item.name,
               isAirport: item.isAirport
            }))
            isPickupDropOpen.value = pickupAddresses.value.length > 0
         }
      }, 400)
   } else {
      isPickupDropOpen.value = false
   }
}

const selectPickupAddress = (item: any) => {
   editForm.value.pickup_location = item.name
   isPickupDropOpen.value = false
}

const handleDropoffSearch = () => {
   const val = editForm.value.dropoff_location.trim()
   if (val.length > 2) {
      if (dropoffTimeout) clearTimeout(dropoffTimeout)
      dropoffTimeout = setTimeout(async () => {
         isDropoffLoading.value = true
         const response = await searchLocation(val)
         isDropoffLoading.value = false
         if (response.status === 200) {
            const predictions = sortPlacePredictions(response.data.data)
            dropoffAddresses.value = predictions.map((item: any) => ({
               name: item.name,
               isAirport: item.isAirport
            }))
            isDropoffDropOpen.value = dropoffAddresses.value.length > 0
         }
      }, 400)
   } else {
      isDropoffDropOpen.value = false
   }
}

const selectDropoffAddress = (item: any) => {
   editForm.value.dropoff_location = item.name
   isDropoffDropOpen.value = false
}

const clickOutsideListener = () => {
   isPickupDropOpen.value = false
   isDropoffDropOpen.value = false
}

onMounted(async () => {
   document.addEventListener('click', clickOutsideListener)

   const authUser = isLoggedIn()
   authAdminUser = isAdminLoggedIn()

   if (route.query.status) {
      statusFilterValue.value = route.query.status as string
      applyStatusFilter()
   }

   await fetchBookings(authUser ? authUser.user.type : '')
})

onBeforeUnmount(() => {
   document.removeEventListener('click', clickOutsideListener)
})

const isWeb = computed(() => {
   const authUser = isLoggedIn()
   return authUser && authUser.user.type == 'web'
})

const fetchBookings = async (userType: string) => {
   isLoading.value = true
   let response: any = { status: 0, data: [] }

   if (userType === 'corporate') {
      response = await allCorporateBookings()
   } else if (userType === 'agent') {
      if (props.subUserId == '') {
         response = await allAgentBookings()
         await fetchSubAgents()
      } else {
         response = await subAgentBookings(props.subUserId)
      }
   } else if (userType === 'web') {
      try {
         const baseUrl = getBackendBaseUrl()
         response = await axios.get(`${baseUrl}api/bookings/protected/my-list`, {
            headers: {
               'Authorization': `Bearer ${getUserToken()}`,
               'Content-Type': 'application/json',
            }
         })
      } catch (err: any) {
         response = err.response || { status: 500 }
      }
   } else if (authAdminUser.value) {
      response = await allBookings()
   }

   isLoading.value = false

   if (response.status == 200) {
      bookings.value = response.data.sort((a: any, b: any) => {
         const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0
         const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0
         return dateB - dateA
      })
   } else if (response.response && response.response.status == 401) {
      logout(router)
   }
}

const fetchSubAgents = async () => {

   const response = await subAgents()

   if (response.status == 200) {
      mySubAgents.value = response.data
   } else {
      const error = handleApiError(response)
      console.log(error)
   }
}

const handleBookingDetails = (booking: any) => {

   selectedBooking.value = booking
   openDialog.value = true
}

const getBookingStatusText = (data: any) => {
   if (!data) return 'Pending and Unpaid'
   if (data.status === 'cancelled') {
      return 'Cancelled'
   }
   if (data.status === 'confirmed') {
      if (data.payment?.status === 'paid') {
         return data.payment?.wallet === 'wallet' ? 'Agency Credit' : 'Paid'
      }
      return 'Confirmed and Unpaid'
   }
   return 'Pending and Unpaid'
}

const getBookingStatusClass = (data: any) => {
   if (!data) return 'bg-purple-50 text-purple-700 border border-purple-200'
   if (data.status === 'cancelled') {
      return 'bg-red-50 text-red-700 border border-red-200'
   }
   if (data.status === 'confirmed') {
      if (data.payment?.status === 'paid') {
         return data.payment?.wallet === 'wallet' 
            ? 'bg-blue-50 text-blue-700 border border-blue-200' 
            : 'bg-green-50 text-green-700 border border-green-200'
      }
      return 'bg-amber-50 text-amber-700 border border-amber-200'
   }
   return 'bg-purple-50 text-purple-700 border border-purple-200'
}

const getStatusClass = (status: string) => {
   if (status == 'incomplete') {
      return 'bg-purple-50 text-purple-700 border border-purple-200'
   } else if (status == 'confirmed') {
      return 'bg-green-50 text-green-700 border border-green-200'
   } else if (status == 'awaiting_payment') {
      return 'bg-amber-50 text-amber-700 border border-amber-200'
   } else if (status == 'need_confirmation') {
      return 'bg-blue-50 text-blue-700 border border-blue-200'
   } else if (status == 'cancelled') {
      return 'bg-red-50 text-red-700 border border-red-200'
   } else if (status == 'unconfirmed') {
      return 'bg-blue-50 text-blue-700 border border-blue-200'
   } else {
      return 'bg-gray-50 text-gray-700 border border-gray-200'
   }
}

const filters = ref()
const statuses = STATUSES.map(status => status.title)
const mySubAgents = ref<any[]>([])
const loading = ref(false)
const dt = ref()

const statusFilterValue = ref('')
const bookedByFilterValue = ref('')
const sourceFilterValue = ref('')

const applyStatusFilter = () => {
   if (statusFilterValue.value) {
      filters.value['status'].constraints[0].value = statusFilterValue.value
   } else {
      filters.value['status'].constraints[0].value = null
   }
}

const applyBookedByFilter = () => {
   if (bookedByFilterValue.value) {
      const agentObj = mySubAgents.value.find((a: any) => a.name === bookedByFilterValue.value)
      filters.value['bookedBy'].value = agentObj ? [agentObj] : null
   } else {
      filters.value['bookedBy'].value = null
   }
}

const applySourceFilter = () => {
   if (sourceFilterValue.value) {
      filters.value['source'].constraints[0].value = sourceFilterValue.value
   } else {
      filters.value['source'].constraints[0].value = null
   }
}

const initFilters = () => {
   filters.value = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      number: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
      status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
      'search.pickUp.date': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
      bookedBy: { value: null, matchMode: FilterMatchMode.IN },
      source: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
   }
}

initFilters()

const clearFilter = () => {
   initFilters()
   statusFilterValue.value = ''
   bookedByFilterValue.value = ''
   sourceFilterValue.value = ''
}

const exportCSV = (event: any) => {
   dt.value.exportCSV()
}

const makeBookingPayment = (booking: any) => {

   saveUserSearch(booking.search)
   saveBookingNumber(booking.number)
   saveSelectedCar(booking.car)
   router.push({name: 'BookingWizard', params: {step: 'contact-details'}})
}

const downloadingItem = ref<any>(null)
const downloadInvoiceRef = ref<HTMLElement | null>(null)
const downloadVoucherRef = ref<HTMLElement | null>(null)

const downloadDocument = async (type: 'voucher' | 'invoice', booking: any) => {
   const number = booking.number
   if (!number) return

   try {
      const baseUrl = getBackendBaseUrl()
      // invoice maps to downloadReceiptPdf endpoint
      const endpoint = type === 'invoice' ? 'receipt' : 'voucher'
      const url = `${baseUrl}api/bookings/pdf/${endpoint}/${number}`

      // Fetch the PDF blob from Laravel
      const response = await fetch(url)
      if (!response.ok) throw new Error(`Failed to download ${type} PDF`)

      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = type === 'invoice' ? `Invoice_${number}.pdf` : `Voucher_${number}.pdf`
      link.click()
      URL.revokeObjectURL(link.href)
   } catch (err) {
      console.error('Download failed:', err)
   }
}

// Edit & Cancel Request States & Logic
const isEditModalOpen = ref(false)
const isCancelModalOpen = ref(false)
const editStep = ref<'form' | 'preview'>('form')
const cancelReason = ref('')
const cancelReasonError = ref(false)
const editingBooking = ref<any>(null)
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: '' })

const notifClosed = () => {
   notif.value.show = false
}

const editForm = ref({
   contact_name: '',
   contact_email: '',
   contact_phone: '',
   contact_flight_number: '',
   pickup_date: '',
   pickup_time: '',
   hours: 10,
   pickup_location: '',
   dropoff_location: '',
   comments: ''
})

const changeSummary = ref<Array<{ field: string, old: string, new: string, key: string }>>([])

const handleEditBooking = (booking: any) => {
   editingBooking.value = booking

   // Format Date to YYYY-MM-DD for HTML5 date input
   let rawDate = booking.search?.pickUp?.date || '';
   if (rawDate) {
      const parts = rawDate.split(/[-/]/);
      if (parts.length === 3) {
         if (parts[2].length === 4) { // DD-MM-YYYY
            rawDate = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
         } else if (parts[0].length === 4) { // YYYY-MM-DD
            rawDate = `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
         }
      }
   }

   // Format Time to 24h format (HH:mm) for HTML5 time input
   let rawTime = booking.search?.pickUp?.time || '';
   if (rawTime) {
      const match = rawTime.match(/^(\d{1,2}):(\d{2})\s*(am|pm)?$/i);
      if (match) {
         let hours = parseInt(match[1]);
         const minutes = match[2];
         const ampm = match[3] ? match[3].toLowerCase() : '';
         if (ampm === 'pm' && hours < 12) {
            hours += 12;
         } else if (ampm === 'am' && hours === 12) {
            hours = 0;
         }
         rawTime = `${String(hours).padStart(2, '0')}:${minutes}`;
      }
   }

   editForm.value = {
      contact_name: booking.contact?.name || booking.contact_name || '',
      contact_email: booking.contact?.email || booking.contact_email || '',
      contact_phone: booking.contact?.phone || booking.contact_phone || '',
      contact_flight_number: booking.contact_flight_number || '',
      pickup_date: rawDate,
      pickup_time: rawTime,
      hours: booking.search?.hours || 10,
      pickup_location: booking.search?.pickUp?.location?.name || '',
      dropoff_location: booking.search?.dropOff?.location?.name || '',
      comments: booking.comments || ''
   }
   editStep.value = 'form'
   isEditModalOpen.value = true
}

const generateChangeSummary = () => {
   const summary = []
   const orig = editingBooking.value
   const form = editForm.value

   const origName = orig.contact?.name || orig.contact_name || ''
   if (origName !== form.contact_name) {
      summary.push({ field: 'Contact Name', old: origName, new: form.contact_name, key: 'contact_name' })
   }

   const origEmail = orig.contact?.email || orig.contact_email || ''
   if (origEmail !== form.contact_email) {
      summary.push({ field: 'Contact Email', old: origEmail, new: form.contact_email, key: 'contact_email' })
   }

   const origPhone = orig.contact?.phone || orig.contact_phone || ''
   if (origPhone !== form.contact_phone) {
      summary.push({ field: 'Contact Phone', old: origPhone, new: form.contact_phone, key: 'contact_phone' })
   }

   const origFlight = orig.contact_flight_number || ''
   if (origFlight !== form.contact_flight_number) {
      summary.push({ field: 'Flight Number', old: origFlight, new: form.contact_flight_number, key: 'flight_number' })
   }

   const origDate = orig.search?.pickUp?.date || ''
   if (origDate !== form.pickup_date) {
      summary.push({ field: 'Pickup Date', old: origDate, new: form.pickup_date, key: 'pickup_date' })
   }

   const origTime = orig.search?.pickUp?.time || ''
   if (origTime !== form.pickup_time) {
      summary.push({ field: 'Pickup Time', old: origTime, new: form.pickup_time, key: 'pickup_time' })
   }

   const isHourly = orig.type === 'hourly' || orig.search?.type === 'hourly' || orig.type === 'chauffer'
   if (isHourly) {
      const origHours = orig.search?.hours || 10
      if (parseInt(origHours) !== parseInt(form.hours as any)) {
         summary.push({ field: 'Hours', old: String(origHours), new: String(form.hours), key: 'hours' })
      }
   }

   const origPickupLoc = orig.search?.pickUp?.location?.name || ''
   if (origPickupLoc !== form.pickup_location) {
      summary.push({ field: 'Pickup Location', old: origPickupLoc, new: form.pickup_location, key: 'pickup_location' })
   }

   if (!isHourly) {
      const origDropoffLoc = orig.search?.dropOff?.location?.name || ''
      if (origDropoffLoc !== form.dropoff_location) {
         summary.push({ field: 'Drop-off Location', old: origDropoffLoc, new: form.dropoff_location, key: 'dropoff_location' })
      }
   }

   const origComments = orig.comments || ''
   if (origComments !== form.comments) {
      summary.push({ field: 'Comments', old: origComments, new: form.comments, key: 'comments' })
   }

   changeSummary.value = summary
}

const showChangePreview = () => {
   generateChangeSummary()
   if (changeSummary.value.length === 0) {
      notif.value = { show: true, type: 'error', message: 'No changes', messageDetails: 'No fields were modified.' }
      return
   }
   editStep.value = 'preview'
}

const submitChangeRequest = async () => {
   isLoading.value = true
   try {
      const payloadChanges: Record<string, { old: string, new: string }> = {}
      changeSummary.value.forEach(item => {
         payloadChanges[item.field] = { old: item.old, new: item.new }
      })

      const baseUrl = getBackendBaseUrl()
      const url = isWeb.value
         ? `${baseUrl}api/bookings/protected/${editingBooking.value.id}/change-request`
         : `${baseUrl}api/agent/bookings/${editingBooking.value.id}/change-request`
      const response = await axios.post(url, {
         changes: payloadChanges
      }, {
         headers: {
            'Authorization': `Bearer ${getUserToken()}`,
            'Content-Type': 'application/json'
         }
      })

      if (response.status === 201) {
         isEditModalOpen.value = false
         notif.value = { show: true, type: 'success', message: 'Submitted', messageDetails: 'Your change request has been submitted. Our agency will get back to you shortly.' }
         setTimeout(() => { notifClosed() }, 5000)
      } else {
         notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Failed to submit change request. Please try again.' }
      }
   } catch (err: any) {
      console.error(err)
      const errorMsg = err.response?.data?.error || 'An error occurred.'
      notif.value = { show: true, type: 'error', message: 'Submission Failed', messageDetails: errorMsg }
   } finally {
      isLoading.value = false
   }
}

const handleCancelBooking = (booking: any) => {
   editingBooking.value = booking
   cancelReason.value = ''
   cancelReasonError.value = false
   isCancelModalOpen.value = true
}

const submitCancellationRequest = async () => {
   if (!cancelReason.value.trim()) {
      cancelReasonError.value = true
      return
   }

   isLoading.value = true
   try {
      const baseUrl = getBackendBaseUrl()
      const url = isWeb.value
         ? `${baseUrl}api/bookings/protected/${editingBooking.value.id}/cancel-request`
         : `${baseUrl}api/agent/bookings/${editingBooking.value.id}/cancel-request`
      const response = await axios.post(url, {
         reason: cancelReason.value
      }, {
         headers: {
            'Authorization': `Bearer ${getUserToken()}`,
            'Content-Type': 'application/json'
         }
      })

      if (response.status === 201) {
         isCancelModalOpen.value = false
         notif.value = { show: true, type: 'success', message: 'Submitted', messageDetails: 'Your cancel request has been submitted. Our team will get back to you shortly.' }
         setTimeout(() => { notifClosed() }, 5000)
      } else {
         notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Failed to submit cancellation request. Please try again.' }
      }
   } catch (err: any) {
      console.error(err)
      const errorMsg = err.response?.data?.error || 'An error occurred.'
      notif.value = { show: true, type: 'error', message: 'Submission Failed', messageDetails: errorMsg }
   } finally {
      isLoading.value = false
   }
}


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (isWeb.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (bookings.value && bookings.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookings.value, (booking) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: booking.number,
                          class: "bg-white rounded-2xl border border-gray-100 p-5 hover:border-theme-active/30 hover:shadow-sm transition-all duration-300 flex flex-col md:flex-row md:items-center justify-between gap-4"
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, "#" + _toDisplayString(booking.number), 1),
                                (booking.refNumber && !booking.refNumber.startsWith('ORD-'))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Online Ref: #" + _toDisplayString(booking.refNumber), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _cache[26] || (_cache[26] = _createElementVNode("i", {
                                  class: "pi pi-calendar text-theme-active",
                                  style: {"font-size":"0.9rem"}
                                }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(booking.search?.pickUp?.date) + " at " + _toDisplayString(booking.search?.pickUp?.time), 1)
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass([getBookingStatusClass(booking), "inline-flex items-center justify-center px-3 py-1 rounded-full text-[9px] font-extrabold uppercase tracking-widest shadow-sm"])
                              }, _toDisplayString(getBookingStatusText(booking)), 3)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _cache[27] || (_cache[27] = _createElementVNode("i", {
                                  class: "pi pi-car text-gray-400",
                                  style: {"font-size":"0.9rem"}
                                }, null, -1)),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(booking.car?.name || booking.car_meta?.name || 'Standard Vehicle'), 1)
                              ]),
                              (booking.search?.pickUp?.location?.name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _cache[30] || (_cache[30] = _createElementVNode("i", {
                                      class: "pi pi-map-marker text-theme-active font-bold",
                                      style: {"font-size":"0.9rem"}
                                    }, null, -1)),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(booking.search?.pickUp?.location?.name), 1),
                                    ((booking.type === 'distance' || booking.search?.type === 'distance') && booking.search?.dropOff?.location?.name)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _cache[28] || (_cache[28] = _createElementVNode("i", {
                                            class: "pi pi-arrow-right text-gray-400 mx-1",
                                            style: {"font-size":"0.75rem"}
                                          }, null, -1)),
                                          _cache[29] || (_cache[29] = _createElementVNode("i", {
                                            class: "pi pi-map-marker text-red-500 font-bold",
                                            style: {"font-size":"0.9rem"}
                                          }, null, -1)),
                                          _createElementVNode("span", _hoisted_15, _toDisplayString(booking.search?.dropOff?.location?.name), 1)
                                        ], 64))
                                      : (booking.type === 'hourly' || booking.search?.type === 'hourly' || booking.type === 'chauffer')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Hourly (" + _toDisplayString(booking.search?.hours || 10) + " hrs) ", 1))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (booking.status !== 'cancelled')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (downloadDocument('invoice', booking)),
                                  type: "button",
                                  class: "inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-xs font-bold rounded-xl bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white transition-all duration-300 border border-indigo-200/50 min-w-[110px] shadow-sm"
                                }, _cache[31] || (_cache[31] = [
                                  _createElementVNode("i", {
                                    class: "pi pi-file",
                                    style: {"font-size":"0.75rem"}
                                  }, null, -1),
                                  _createTextVNode(" Invoice ")
                                ]), 8, _hoisted_18),
                                (booking.status === 'confirmed' && booking.payment?.status === 'paid')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (downloadDocument('voucher', booking)),
                                      type: "button",
                                      class: "inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-xs font-bold rounded-xl bg-theme-active/10 text-theme-active hover:bg-theme-active hover:text-white transition-all duration-300 border border-theme-active/20 min-w-[110px] shadow-sm"
                                    }, _cache[32] || (_cache[32] = [
                                      _createElementVNode("i", {
                                        class: "pi pi-download",
                                        style: {"font-size":"0.75rem"}
                                      }, null, -1),
                                      _createTextVNode(" Voucher ")
                                    ]), 8, _hoisted_19))
                                  : _createCommentVNode("", true),
                                (booking.source === 'Online' || !booking.source)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (handleEditBooking(booking)),
                                        type: "button",
                                        class: "inline-flex items-center justify-center gap-1 px-4 py-2.5 text-xs font-bold rounded-xl bg-amber-50 text-amber-600 hover:bg-amber-600 hover:text-white transition-all duration-300 border border-amber-200/50 min-w-[110px] shadow-sm"
                                      }, _cache[33] || (_cache[33] = [
                                        _createElementVNode("i", {
                                          class: "pi pi-pencil",
                                          style: {"font-size":"0.75rem"}
                                        }, null, -1),
                                        _createTextVNode(" Edit ")
                                      ]), 8, _hoisted_20),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (handleCancelBooking(booking)),
                                        type: "button",
                                        class: "inline-flex items-center justify-center gap-1 px-4 py-2.5 text-xs font-bold rounded-xl bg-rose-50 text-rose-600 hover:bg-rose-600 hover:text-white transition-all duration-300 border border-rose-200/50 min-w-[110px] shadow-sm"
                                      }, _cache[34] || (_cache[34] = [
                                        _createElementVNode("i", {
                                          class: "pi pi-times-circle",
                                          style: {"font-size":"0.75rem"}
                                        }, null, -1),
                                        _createTextVNode(" Cancel ")
                                      ]), 8, _hoisted_21)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[35] || (_cache[35] = [
                      _createElementVNode("div", { class: "h-14 w-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-400" }, [
                        _createElementVNode("i", {
                          class: "pi pi-calendar-times",
                          style: {"font-size":"1.5rem"}
                        })
                      ], -1),
                      _createElementVNode("h3", { class: "text-gray-900 font-bold text-base mb-1" }, "No Reservations Found", -1),
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-500 max-w-sm mx-auto leading-relaxed font-regular" }, "You haven't made any transfer bookings yet. Ready to plan your next transfer journey?", -1)
                    ])))
              ]))
            : (_openBlock(), _createBlock(_component_DataTable, {
                key: 1,
                exportFilename: "bookings",
                ref_key: "dt",
                ref: dt,
                class: "text-sm",
                filters: filters.value,
                "onUpdate:filters": _cache[9] || (_cache[9] = ($event: any) => ((filters).value = $event)),
                value: filteredBookings.value,
                paginator: "",
                showGridlines: "",
                rows: 10,
                dataKey: "id",
                filterDisplay: "menu",
                loading: isLoading.value,
                globalFilterFields: [
             'number',
             'status', 
             'search.pickUp.date', 
             'search.pickUp.time', 
             'search.pickUp.location.name',
             'car.name',
             'contact.name', 
             'contact.email', 
             'contact.phone',
             'bookedBy.name',
             'source',
             'createdAt',
          ]
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-gray-900 font-bold text-base flex items-center gap-2" }, [
                        _createElementVNode("i", {
                          class: "pi pi-list text-theme-active",
                          style: {"font-size":"1rem","font-weight":"bold"}
                        }),
                        _createTextVNode(" Reservation Records ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter())),
                          class: "inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-xl border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 transition-all duration-300 shadow-sm"
                        }, _cache[36] || (_cache[36] = [
                          _createElementVNode("i", {
                            class: "pi pi-filter-slash",
                            style: {"font-size":"0.8rem"}
                          }, null, -1),
                          _createTextVNode(" Clear ")
                        ])),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (exportCSV($event))),
                          class: "inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-xl bg-theme-active text-white hover:bg-theme-active/90 transition-all duration-300 shadow-sm"
                        }, _cache[37] || (_cache[37] = [
                          _createElementVNode("i", {
                            class: "pi pi-external-link",
                            style: {"font-size":"0.8rem"}
                          }, null, -1),
                          _createTextVNode(" Export ")
                        ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" }, [
                          _createElementVNode("i", {
                            class: "pi pi-search",
                            style: {"font-size":"0.8rem"}
                          })
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value['global'].value) = $event)),
                          placeholder: "Search reservations...",
                          class: "pl-9 pr-4 py-2 border border-gray-200 rounded-xl text-sm w-full sm:w-64 bg-white focus:outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent transition-all duration-300"
                        }, null, 512), [
                          [_vModelText, filters.value['global'].value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedDateScope).value = $event)),
                          class: "w-full pl-3 pr-8 py-2 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent appearance-none transition-all duration-300 cursor-pointer"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scopes.value, (scope) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: scope.id,
                              value: scope.id
                            }, _toDisplayString(scope.name), 9, _hoisted_29))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, selectedDateScope.value]
                        ]),
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" }, [
                          _createElementVNode("i", { class: "pi pi-chevron-down text-xs" })
                        ], -1))
                      ]),
                      (selectedDateScope.value === 'custom')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((startDate).value = $event)),
                              class: "border border-gray-250 rounded-xl px-3 py-1.5 text-sm outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent"
                            }, null, 512), [
                              [_vModelText, startDate.value]
                            ]),
                            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-gray-400 text-sm" }, "to", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((endDate).value = $event)),
                              class: "border border-gray-250 rounded-xl px-3 py-1.5 text-sm outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent"
                            }, null, 512), [
                              [_vModelText, endDate.value]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((statusFilterValue).value = $event)),
                          onChange: applyStatusFilter,
                          class: "w-full pl-3 pr-8 py-2 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent appearance-none transition-all duration-300"
                        }, [
                          _cache[42] || (_cache[42] = _createElementVNode("option", { value: "" }, "All Statuses", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(STATUSES), (status) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: status.id,
                              value: status.name
                            }, _toDisplayString(status.title), 9, _hoisted_32))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, statusFilterValue.value]
                        ]),
                        _cache[43] || (_cache[43] = _createElementVNode("span", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" }, [
                          _createElementVNode("i", { class: "pi pi-chevron-down text-xs" })
                        ], -1))
                      ]),
                      (!isWeb.value && mySubAgents.value && mySubAgents.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bookedByFilterValue).value = $event)),
                              onChange: applyBookedByFilter,
                              class: "w-full pl-3 pr-8 py-2 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent appearance-none transition-all duration-300"
                            }, [
                              _cache[44] || (_cache[44] = _createElementVNode("option", { value: "" }, "All Agents", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mySubAgents.value, (agent) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: agent.id,
                                  value: agent.name
                                }, _toDisplayString(agent.name), 9, _hoisted_34))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, bookedByFilterValue.value]
                            ]),
                            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" }, [
                              _createElementVNode("i", { class: "pi pi-chevron-down text-xs" })
                            ], -1))
                          ]))
                        : _createCommentVNode("", true),
                      (!isWeb.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((sourceFilterValue).value = $event)),
                              onChange: applySourceFilter,
                              class: "w-full pl-3 pr-8 py-2 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent appearance-none transition-all duration-300"
                            }, _cache[46] || (_cache[46] = [
                              _createElementVNode("option", { value: "" }, "All Sources", -1),
                              _createElementVNode("option", { value: "Online" }, "Online", -1),
                              _createElementVNode("option", { value: "Offline" }, "Offline", -1)
                            ]), 544), [
                              [_vModelSelect, sourceFilterValue.value]
                            ]),
                            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" }, [
                              _createElementVNode("i", { class: "pi pi-chevron-down text-xs" })
                            ], -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                empty: _withCtx(() => _cache[48] || (_cache[48] = [
                  _createTextVNode(" No bookings found. ")
                ])),
                loading: _withCtx(() => _cache[49] || (_cache[49] = [
                  _createTextVNode(" Loading bookings data. Please wait. ")
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "number",
                    header: "Booking Number & Date",
                    exportHeader: "Booking Number"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("span", _hoisted_37, "#" + _toDisplayString(data.number), 1),
                        (data.refNumber && !data.refNumber.startsWith('ORD-'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Online Ref: #" + _toDisplayString(data.refNumber), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(data.createdAt ? _unref(formattedDateTime)(data.createdAt) : 'N/A'), 1)
                      ])
                    ]),
                    filter: _withCtx(({ filterModel }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        type: "text",
                        class: "p-column-filter",
                        placeholder: "Search booking number"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "contact.name",
                    exportHeader: "Customer Name",
                    class: "hidden"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.contact.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "contact.phone",
                    exportHeader: "Customer Phone",
                    class: "hidden"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.contact.phone), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Booking Details",
                    exportable: false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _cache[50] || (_cache[50] = _createElementVNode("span", { class: "font-bold text-gray-900" }, "Booked By:", -1)),
                          _createElementVNode("span", _hoisted_42, _toDisplayString(data.bookedBy ? data.bookedBy.name : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "font-bold text-gray-900" }, "Pickup Date:", -1)),
                          _createElementVNode("span", _hoisted_44, _toDisplayString(data.search?.pickUp?.date) + " - " + _toDisplayString(data.search?.pickUp?.time), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _cache[52] || (_cache[52] = _createElementVNode("span", { class: "font-bold text-gray-900" }, "Booked Car:", -1)),
                          _createElementVNode("span", _hoisted_46, _toDisplayString(data.car?.name || data.car_meta?.name || 'Standard Vehicle'), 1)
                        ]),
                        (data.loyalty_points)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createElementVNode("span", _hoisted_48, " +" + _toDisplayString(Number(data.loyalty_points).toFixed(2)) + " Loyalty Points ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _cache[54] || (_cache[54] = _createElementVNode("i", {
                              class: "pi pi-map-marker text-green-600 mt-0.5",
                              style: {"font-size":"0.7rem"}
                            }, null, -1)),
                            _createElementVNode("span", {
                              class: "font-medium text-gray-600 line-clamp-1",
                              title: data.search?.pickUp?.location?.name
                            }, [
                              _cache[53] || (_cache[53] = _createElementVNode("strong", null, "Pick:", -1)),
                              _createTextVNode(" " + _toDisplayString(data.search?.pickUp?.location?.name || 'N/A'), 1)
                            ], 8, _hoisted_51)
                          ]),
                          ((data.type === 'distance' || data.search?.type === 'distance') && data.search?.dropOff?.location?.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _cache[56] || (_cache[56] = _createElementVNode("i", {
                                  class: "pi pi-map-marker text-red-500 mt-0.5",
                                  style: {"font-size":"0.7rem"}
                                }, null, -1)),
                                _createElementVNode("span", {
                                  class: "font-medium text-gray-600 line-clamp-1",
                                  title: data.search?.dropOff?.location?.name
                                }, [
                                  _cache[55] || (_cache[55] = _createElementVNode("strong", null, "Drop:", -1)),
                                  _createTextVNode(" " + _toDisplayString(data.search?.dropOff?.location?.name), 1)
                                ], 8, _hoisted_53)
                              ]))
                            : (data.type === 'hourly' || data.search?.type === 'hourly' || data.type === 'chauffer')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                  _createElementVNode("span", _hoisted_55, " Hourly (" + _toDisplayString(data.search?.hours || 10) + " hrs) ", 1)
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "search.pickUp.location.name",
                    exportHeader: "Pick up",
                    class: "hidden"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.search.pickUp.location.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "search.pickUp.date",
                    exportHeader: "Pick up date",
                    class: "hidden"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.search.pickUp.date), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "search.pickUp.time",
                    exportHeader: "Pick up time",
                    class: "hidden"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.search.pickUp.time), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Amount",
                    field: "totalAmount",
                    style: {"min-width":"8rem"}
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("span", _hoisted_57, " USD " + _toDisplayString(parseFloat(data.totalAmount || 0).toFixed(2)), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass([data.source === 'Online' ? 'bg-teal-50 text-teal-700 border border-teal-200' : 'bg-gray-50 text-gray-700 border border-gray-200', "inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wider w-fit shadow-xs"])
                        }, _toDisplayString(data.source || 'Online'), 3)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Payment & Booking Status",
                    field: "status"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("span", {
                          class: _normalizeClass([getBookingStatusClass(data), "inline-flex items-center justify-center px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-wider min-w-[120px] shadow-sm text-center"])
                        }, _toDisplayString(getBookingStatusText(data)), 3),
                        (data.payment?.status === 'paid' && data.payment?.date)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_unref(formattedDateTime)(data.payment.date)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Actions",
                    exportable: false,
                    style: {"min-width":"16rem"}
                  }, {
                    body: _withCtx(({ data }) => [
                      (data.status !== 'cancelled')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            (data.status === 'confirmed' && data.payment?.status === 'paid')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (downloadDocument('voucher', data)),
                                  type: "button",
                                  class: "inline-flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-bold rounded-lg bg-theme-active/10 text-theme-active hover:bg-theme-active hover:text-white transition-all duration-300 shadow-sm border border-theme-active/20"
                                }, _cache[57] || (_cache[57] = [
                                  _createElementVNode("i", {
                                    class: "pi pi-download",
                                    style: {"font-size":"0.65rem"}
                                  }, null, -1),
                                  _createTextVNode(" Voucher ")
                                ]), 8, _hoisted_61))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (downloadDocument('invoice', data)),
                              type: "button",
                              class: "inline-flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-bold rounded-lg bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white transition-all duration-300 shadow-sm border border-indigo-200/50"
                            }, _cache[58] || (_cache[58] = [
                              _createElementVNode("i", {
                                class: "pi pi-file",
                                style: {"font-size":"0.65rem"}
                              }, null, -1),
                              _createTextVNode(" Invoice ")
                            ]), 8, _hoisted_62),
                            (data.source === 'Online' || !data.source)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (handleEditBooking(data)),
                                    type: "button",
                                    class: "inline-flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-bold rounded-lg bg-amber-50 text-amber-600 hover:bg-amber-600 hover:text-white transition-all duration-300 shadow-sm border border-amber-200/50"
                                  }, _cache[59] || (_cache[59] = [
                                    _createElementVNode("i", {
                                      class: "pi pi-pencil",
                                      style: {"font-size":"0.65rem"}
                                    }, null, -1),
                                    _createTextVNode(" Edit ")
                                  ]), 8, _hoisted_63),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (handleCancelBooking(data)),
                                    type: "button",
                                    class: "inline-flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-bold rounded-lg bg-rose-50 text-rose-600 hover:bg-rose-600 hover:text-white transition-all duration-300 shadow-sm border border-rose-200/50"
                                  }, _cache[60] || (_cache[60] = [
                                    _createElementVNode("i", {
                                      class: "pi pi-times-circle",
                                      style: {"font-size":"0.65rem"}
                                    }, null, -1),
                                    _createTextVNode(" Cancel ")
                                  ]), 8, _hoisted_64)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["filters", "value", "loading"]))
        ]))
      : _createCommentVNode("", true),
    (downloadingItem.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
          (downloadingItem.value.type === 'invoice')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "downloadInvoiceRef",
                ref: downloadInvoiceRef,
                class: "w-full bg-white"
              }, [
                _createVNode(Invoice, {
                  data: downloadingItem.value.data
                }, null, 8, ["data"])
              ], 512))
            : _createCommentVNode("", true),
          (downloadingItem.value.type === 'voucher')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                ref_key: "downloadVoucherRef",
                ref: downloadVoucherRef,
                class: "w-full bg-white"
              }, [
                _createVNode(Voucher, {
                  data: downloadingItem.value.data
                }, null, 8, ["data"])
              ], 512))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isEditModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("h3", _hoisted_69, _toDisplayString(editStep.value === 'form' ? 'Edit Booking Details' : 'Confirm Changes'), 1),
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (isEditModalOpen.value = false)),
                class: "text-gray-400 hover:text-gray-600"
              }, _cache[61] || (_cache[61] = [
                _createElementVNode("i", { class: "pi pi-times text-lg" }, null, -1)
              ]))
            ]),
            (editStep.value === 'form')
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", null, [
                      _cache[62] || (_cache[62] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Contact Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.contact_name) = $event)),
                        class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active"
                      }, null, 512), [
                        [_vModelText, editForm.value.contact_name]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[63] || (_cache[63] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Contact Email", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editForm.value.contact_email) = $event)),
                        class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active"
                      }, null, 512), [
                        [_vModelText, editForm.value.contact_email]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[64] || (_cache[64] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Contact Phone", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editForm.value.contact_phone) = $event)),
                        class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active"
                      }, null, 512), [
                        [_vModelText, editForm.value.contact_phone]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[65] || (_cache[65] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Flight Number", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editForm.value.contact_flight_number) = $event)),
                        class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active",
                        placeholder: "e.g. EK123"
                      }, null, 512), [
                        [_vModelText, editForm.value.contact_flight_number]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[66] || (_cache[66] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Pickup Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editForm.value.pickup_date) = $event)),
                        class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active"
                      }, null, 512), [
                        [_vModelText, editForm.value.pickup_date]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[67] || (_cache[67] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Pickup Time", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "time",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editForm.value.pickup_time) = $event)),
                        class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active"
                      }, null, 512), [
                        [_vModelText, editForm.value.pickup_time]
                      ])
                    ]),
                    (editingBooking.value?.type === 'hourly' || editingBooking.value?.search?.type === 'hourly' || editingBooking.value?.type === 'chauffer')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _cache[68] || (_cache[68] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Duration (Hours)", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editForm.value.hours) = $event)),
                            class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active",
                            min: "1"
                          }, null, 512), [
                            [_vModelText, editForm.value.hours]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _cache[70] || (_cache[70] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Pickup Location", -1)),
                    _createElementVNode("div", _hoisted_74, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((editForm.value.pickup_location) = $event)),
                        onInput: handlePickupSearch,
                        class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active pr-8",
                        placeholder: "Type to search pickup location..."
                      }, null, 544), [
                        [_vModelText, editForm.value.pickup_location]
                      ]),
                      (isPickupLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, _cache[69] || (_cache[69] = [
                            _createElementVNode("i", { class: "pi pi-spin pi-spinner text-gray-400 text-sm" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ]),
                    (isPickupDropOpen.value && pickupAddresses.value.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_76, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickupAddresses.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              onClick: _withModifiers(($event: any) => (selectPickupAddress(item)), ["stop"]),
                              key: index,
                              class: "flex items-center gap-2 py-2 px-3 hover:bg-gray-50 border-b border-gray-100 text-gray-700 text-xs cursor-pointer"
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass([item.isAirport ? 'pi pi-plane' : 'pi pi-map-marker', "text-gray-400"])
                              }, null, 2),
                              _createElementVNode("span", null, _toDisplayString(item.name), 1)
                            ], 8, _hoisted_77))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!(editingBooking.value?.type === 'hourly' || editingBooking.value?.search?.type === 'hourly' || editingBooking.value?.type === 'chauffer'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _cache[72] || (_cache[72] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Drop-off Location", -1)),
                        _createElementVNode("div", _hoisted_79, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((editForm.value.dropoff_location) = $event)),
                            onInput: handleDropoffSearch,
                            class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active pr-8",
                            placeholder: "Type to search drop-off location..."
                          }, null, 544), [
                            [_vModelText, editForm.value.dropoff_location]
                          ]),
                          (isDropoffLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, _cache[71] || (_cache[71] = [
                                _createElementVNode("i", { class: "pi pi-spin pi-spinner text-gray-400 text-sm" }, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]),
                        (isDropoffDropOpen.value && dropoffAddresses.value.length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_81, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropoffAddresses.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  onClick: _withModifiers(($event: any) => (selectDropoffAddress(item)), ["stop"]),
                                  key: index,
                                  class: "flex items-center gap-2 py-2 px-3 hover:bg-gray-50 border-b border-gray-100 text-gray-700 text-xs cursor-pointer"
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass([item.isAirport ? 'pi pi-plane' : 'pi pi-map-marker', "text-gray-400"])
                                  }, null, 2),
                                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                ], 8, _hoisted_82))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _cache[73] || (_cache[73] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-600 mb-1" }, "Special Comments", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((editForm.value.comments) = $event)),
                      rows: "3",
                      class: "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-theme-active",
                      placeholder: "Any additional request..."
                    }, null, 512), [
                      [_vModelText, editForm.value.comments]
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _createElementVNode("p", _hoisted_84, [
                    _cache[74] || (_cache[74] = _createTextVNode("Please review the changes you are requesting for Booking ")),
                    _createElementVNode("span", _hoisted_85, "#" + _toDisplayString(editingBooking.value?.number), 1),
                    _cache[75] || (_cache[75] = _createTextVNode(":"))
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeSummary.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.key,
                        class: "p-3 grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm"
                      }, [
                        _createElementVNode("span", _hoisted_87, _toDisplayString(item.field), 1),
                        _createElementVNode("span", _hoisted_88, _toDisplayString(item.old || '(Empty)'), 1),
                        _createElementVNode("span", _hoisted_89, "→ " + _toDisplayString(item.new || '(Empty)'), 1)
                      ]))
                    }), 128))
                  ])
                ])),
            _createElementVNode("div", _hoisted_90, [
              (editStep.value === 'form')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: showChangePreview,
                    type: "button",
                    class: "px-5 py-2 text-sm font-bold bg-theme-active text-white rounded-xl hover:bg-theme-active/90 shadow-sm"
                  }, " Save "))
                : _createCommentVNode("", true),
              (editStep.value === 'preview')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (editStep.value = 'form')),
                    type: "button",
                    class: "px-5 py-2 text-sm font-semibold border rounded-xl hover:bg-gray-50 text-gray-700 bg-white"
                  }, " Back "))
                : _createCommentVNode("", true),
              (editStep.value === 'preview')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: submitChangeRequest,
                    type: "button",
                    class: "px-5 py-2 text-sm font-bold bg-green-600 text-white rounded-xl hover:bg-green-700 shadow-sm"
                  }, " Confirm Request "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[22] || (_cache[22] = ($event: any) => (isEditModalOpen.value = false)),
                type: "button",
                class: "px-5 py-2 text-sm font-semibold border rounded-xl hover:bg-gray-50 text-gray-700 bg-white"
              }, " Cancel ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isCancelModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _cache[77] || (_cache[77] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900" }, "Cancel Booking Request", -1)),
              _createElementVNode("button", {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (isCancelModalOpen.value = false)),
                class: "text-gray-400 hover:text-gray-600"
              }, _cache[76] || (_cache[76] = [
                _createElementVNode("i", { class: "pi pi-times text-lg" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("p", _hoisted_95, [
                _cache[78] || (_cache[78] = _createTextVNode(" Are you sure you want to request cancellation for booking ")),
                _createElementVNode("span", _hoisted_96, "#" + _toDisplayString(editingBooking.value?.number), 1),
                _cache[79] || (_cache[79] = _createTextVNode("? "))
              ]),
              _createElementVNode("div", null, [
                _cache[80] || (_cache[80] = _createElementVNode("label", { class: "block text-xs font-bold text-gray-600 mb-1" }, [
                  _createTextVNode("Reason for Cancellation "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((cancelReason).value = $event)),
                  rows: "3",
                  class: _normalizeClass([cancelReasonError.value ? 'border-red-500 focus:ring-red-500' : 'border-gray-200 focus:ring-theme-active', "w-full px-3 py-2 border rounded-lg text-sm bg-white outline-none focus:ring-2"]),
                  placeholder: "Please specify the reason..."
                }, null, 2), [
                  [_vModelText, cancelReason.value]
                ]),
                (cancelReasonError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_97, "Cancellation reason is mandatory."))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("button", {
                onClick: submitCancellationRequest,
                type: "button",
                class: "px-5 py-2 text-sm font-bold bg-red-600 text-white rounded-xl hover:bg-red-700 shadow-sm"
              }, " Submit Request "),
              _createElementVNode("button", {
                onClick: _cache[25] || (_cache[25] = ($event: any) => (isCancelModalOpen.value = false)),
                type: "button",
                class: "px-5 py-2 text-sm font-semibold border rounded-xl hover:bg-gray-50 text-gray-700 bg-white"
              }, " Cancel ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_99, " Loading data please wait... "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})